import { Call } from '@twilio/voice-sdk';
import { useReducer, useRef } from 'react';
import { cronoCallReducer } from './cronoCallReducer';
import { useRecordingControls } from './useRecordingControls';
import { useTwilioCallSession } from './useTwilioCallSession';

export const useCronoCall = () => {
  const [state, send] = useReducer(cronoCallReducer, {
    status: 'closed',
  });

  const callRef = useRef<Call>();
  const wasRecorded = useRef(false);

  const { startCall, hangup, mute, playDTMF, changeMicrophone, changeSpeaker } =
    useTwilioCallSession({
      callRef,
      wasRecorded,
      send,
    });

  const { startRecording, confirmRecording, cancelRecording } =
    useRecordingControls({
      callRef,
      state,
      wasRecorded,
      send,
    });

  const openDialpad = (shouldOpen: boolean) => {
    send({ type: 'openDialpad', shouldOpen });
  };

  const openSettings = (shouldOpen: boolean) => {
    send({ type: 'openSettings', shouldOpen });
  };

  return {
    callState: state,
    openDialpad,
    openSettings,
    startCall,
    hangup,
    mute,
    playDTMF,
    changeMicrophone,
    changeSpeaker,
    startRecording,
    confirmRecording,
    cancelRecording,
  };
};
